import PostCompose from './PostCompose'
import PostComposeUpdate from './PostComposeUpdate'
export { PostComposeUpdate }

export default PostCompose
